import * as crypto from 'crypto';
import express, {Express, json, urlencoded} from 'express';
import cors from 'cors';
import compression from 'compression';
import helmet from 'helmet';
import timeout from 'connect-timeout';
import {ServerContract} from 'common/http/ServerContract';
import {Logger} from 'common/tool/Logger';

export class Server implements ServerContract {
    public static readonly DEFAULT_PORT: number = 8080;
    public static readonly SALT: string = '03561b4a0fe7f125025';
    private app: Express;

    public async create(origins: string[], port?: number): Promise<Express> {
        if (this.app === undefined) {
            const backendPort: number = port || Server.DEFAULT_PORT;
            const backendLocalUrl: string = 'http://localhost:' + String(backendPort);
            Logger.debug('start server on ' + backendLocalUrl);
            this.app = express();
            this.app.set('trust proxy', true);
            this.app.disable('x-powered-by');
            this.app.use(compression({level: -1}));
            this.app.use(timeout('300s'));
            this.app.use(json({
                inflate: true,
                limit: '10mb',
                reviver: null,
                strict: true,
                type: 'application/json',
                verify: (req: express.Request, _res: express.Response, buf: Buffer) => {
                    (req as any).rawBody = buf; // Buffer kept before JSON parsing
                }
            }));
            this.app.use(urlencoded({
                limit: '10mb',
                verify: (req: express.Request, _res: express.Response, buf: Buffer) => {
                    (req as any).rawBody = buf; // Buffer kept before JSON parsing
                }
            }));
            this.app.use(cors({
                origin: [backendLocalUrl].concat(origins),
                credentials: true
            }));
            this.app.use(helmet());
            this.app.listen(backendPort, () => {
                Logger.debug('server is running on ' + backendLocalUrl);
            });
        }

        return this.app;
    }

    public getSessionSecret(sessionCookieName: string): string {
        return crypto.createHash('sha1').update(sessionCookieName + Server.SALT).digest('hex');
    }
}
